define('modules/lp_info/views/confirm_delete_popup',['require','exports','module','common/views/modal_view','ldsh!../templates/confirm_delete_popup'],function(require, exports, module) {
  "use strict";

  var ModalView = require("common/views/modal_view");

  module.exports = ModalView.extend({
    template: require("ldsh!../templates/confirm_delete_popup"),
    triggers: {
      "click .js-ok": "ok",
      "click .js-cancel": "cancel"
    },
    onRender: function() {
      this.$el.i18n();
    }
  });

  _.extend(module.exports, {
    show: function(variant) {
      var popup = new module.exports({model: variant}),
          defer = $.Deferred();
      popup.on("ok", _.bind(defer.resolve, defer));
      popup.on("cancel", _.bind(defer.reject, defer));
      defer.always(_.bind(popup.hide, popup));
      return defer.promise();
    }
  });
});

